import { FC, useEffect } from 'react'
import { useLoaderData } from 'react-router-dom'
import { Layout, Order, PaymentRedirect, PaymentCheckout } from '../../components'
import { getButtonStyles, getGlobalCustomStyles, PaymentRouterContainer } from './payment-route.styled'
import { queryClient } from '../../state'
import { CheckoutInfo } from '../../types'
import { checkoutInfoQueryKey } from '../../hooks'
import { Global } from '@emotion/react'
import { dynamicStyle } from './payment-route.styled'
import { dynamicDisplayRedirect } from '../../utils'

export const PaymentRoute: FC = () => {
  const workflow = useLoaderData()
  const checkoutInfo = queryClient.getQueryData<CheckoutInfo>([checkoutInfoQueryKey])
  const displayValue = dynamicDisplayRedirect(checkoutInfo?.checkout_return_url, checkoutInfo?.payment_link?.show_result_screen)

  useEffect(() => {
    if (workflow === 'CHECKOUT') {
      document.dispatchEvent(
        new CustomEvent('yuno-loader-message', { detail: { show: true, variant: 'skeleton' } })
      )
    }
  }, [workflow])

  if (workflow === 'CHECKOUT') {
    return (
      <Layout
        rightContent={<PaymentCheckout />}
      >
        <Global styles={[
          dynamicStyle(displayValue),
          getButtonStyles(checkoutInfo!.payment_link.style),
          getGlobalCustomStyles(checkoutInfo!.payment_link.style),
        ]} />
        <PaymentRouterContainer>
          <Order />
        </PaymentRouterContainer>
      </Layout>
    )
  }

  return (
    <>
      <Global styles={[dynamicStyle(displayValue)]} />
      <PaymentRedirect />
    </>
  )
}
